import {makeAutoObservable} from "mobx";
import {InvoiceRequest} from "../../entity/model/invoice-request";
import InvoiceRequestAgent from "../agent/invoice-request-agent";
import {RequestBody} from "../../entity/core/request-body";

export default class InvoiceTemplateStore {
  invoiceTemplateAgent: InvoiceRequestAgent;
  invoiceRequests: InvoiceRequest[] = [];

  constructor(invoiceTemplateAgent: InvoiceRequestAgent) {
    makeAutoObservable(this);
    this.invoiceTemplateAgent = invoiceTemplateAgent;
  }

  createInvoiceTemplate = async (organizationId: string, requestBody: RequestBody): Promise<InvoiceRequest | string> => {
    try {
      return await this.invoiceTemplateAgent.createInvoiceTemplate(organizationId, requestBody);
    } catch (error: any) {
      console.error('Error occurred while creating the invoice template', error);
      return 'Error occurred while creating the invoice template !!';
    }
  }

  updateInvoiceTemplate = async (organizationId: string, templateId: string, requestBody: RequestBody): Promise<InvoiceRequest | string> => {
    try {
      return await this.invoiceTemplateAgent.updateInvoiceTemplate(organizationId, templateId, requestBody);
    } catch (error: any) {
      console.error('Error occurred while updating the invoice template', error);
      return 'Error occurred while updating the invoice template !!';
    }
  }

  loadInvoiceTemplates = async (organizationId: string, titleId: string): Promise<void> => {
    try {
      this.invoiceRequests = await this.invoiceTemplateAgent.getInvoiceTemplates(organizationId, titleId);
    } catch (error: any) {
      console.error('Error occurred while fetching the invoice templates', error);
    }
  }

  getInvoiceTemplate = (documentId: string): InvoiceRequest | undefined => {
    return this.invoiceRequests.find((invoiceTemplate: InvoiceRequest) => invoiceTemplate.documentID === documentId);
  }

}
